var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-map-pin",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-map-pin1",
    serifid: "iconB-map-pin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.999,1.029c4.692,0.005 8.495,3.808 8.5,8.5c0,2.995 -1.375,6.174 -3.994,9.186l-0.026,0.03c-1.146,1.318 -3.113,3.49 -3.9,4.07c-0.163,0.12 -0.366,0.185 -0.579,0.185c-0.215,-0 -0.414,-0.068 -0.575,-0.182l-0.068,-0.048c-1.404,-1.043 -2.692,-2.707 -3.862,-4.054c-2.62,-3.012 -3.996,-6.192 -3.996,-9.188l0,-0.006c0.006,-4.669 3.771,-8.45 8.431,-8.493c0.016,0 0.04,0 0.069,-0Zm-0.058,0c-0.004,0 -0.008,0 -0.011,0c-0.034,0 -0.035,0 0.011,0Zm0.059,19.589c0.995,-0.796 3.067,-2.96 4.609,-5.363c1.073,-1.671 1.89,-3.629 1.89,-5.726c0,-3.59 -2.91,-6.5 -6.5,-6.5c-3.59,-0 -6.5,2.91 -6.5,6.5c0,2.097 0.818,4.055 1.89,5.726c1.542,2.403 3.616,4.567 4.611,5.363Zm0.004,-15.624c2.409,0.003 4.362,1.955 4.365,4.365c-0,2.411 -1.954,4.365 -4.365,4.365c-2.411,0 -4.365,-1.954 -4.365,-4.365c-0,-2.411 1.954,-4.365 4.365,-4.365Zm-0,6.75c1.316,-0.002 2.383,-1.068 2.385,-2.385c-0,-1.317 -1.068,-2.385 -2.385,-2.385c-1.317,0 -2.385,1.068 -2.385,2.385c-0,1.317 1.068,2.385 2.385,2.385Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBMapPin);
export default __webpack_public_path__ + "static/media/iconB-map-pin.02699f39b60b00116419daf766c3b4dd.svg";
export { ForwardRef as ReactComponent };